import React from 'react';

import { ValueProps } from '../types';

import { Input } from './Input';

export function TextValue({ question, disabled, min, max, pattern }: ValueProps) {
  return (
    <Input name={String(question.id)} type="text" disabled={disabled} minLength={min} maxLength={max} pattern={pattern}/>
  );
}
